/**
 * Demo toast helper.
 *
 * Shown when backend intercepts a mutation in demo mode and returns
 * a 200 response with the shape:
 *   { demo_mode: true, message, cta, contact_email }
 *
 * Uses the app-wide `sonner` toaster (already rendered in App.js).
 * Debounced to avoid spam when multiple mutations fire back-to-back.
 */
import { toast as sonnerToast } from 'sonner';
import { createElement } from 'react';

let lastToastAt = 0;
const DEBOUNCE_MS = 2000;

export function showDemoToast(message, contactEmail) {
  const now = Date.now();
  if (now - lastToastAt < DEBOUNCE_MS) return;
  lastToastAt = now;

  const finalMessage = message || 'Action désactivée en mode démo.';
  const email = contactEmail || 'contact@sylink.fr';
  const mailto = `mailto:${email}?subject=${encodeURIComponent('Demande de démo SYLink Pentest')}`;

  const content = createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
    [
      createElement(
        'div',
        { key: 'msg', style: { fontWeight: 500 } },
        finalMessage
      ),
      createElement(
        'a',
        {
          key: 'cta',
          href: mailto,
          style: {
            color: '#d97706',
            textDecoration: 'underline',
            fontWeight: 600,
            fontSize: '0.875rem',
          },
        },
        `Contactez ${email}`
      ),
    ]
  );

  sonnerToast.warning(content, {
    duration: 5000,
    style: {
      border: '1px solid #f59e0b',
      background: '#fffbeb',
      color: '#1f1f1f',
    },
  });
}

export default showDemoToast;
